import { changeLang } from '@/utils/funcs'
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

function updateLanguage(to, from, next) {
  let query = Object.assign({}, to.query)
  if (query.lang) {
    changeLang(query.lang)
    delete query.lang
  }
  next()
}

const routes = [
  {
    path: '/dashboard/:ticker/:market',
    name: 'Home',
    component: () =>
      import(
        /* webpackChunkName: "Home" */
        /* webpackPreload: true */ // not working here
        '../views/Home'
      ),
  },
  {
    path: '/terms',
    name: 'Terms',
    component: () =>
      import(
        /* webpackChunkName: "Terms" */
        '../views/Terms'
      ),
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: () =>
      import(
        /* webpackChunkName: "Privacy" */
        '../views/Privacy'
      ),
  },
  {
    path: '/screener/:market',
    name: 'Screener',
    component: () =>
      import(
        /* webpackChunkName: "Screener" */
        '../views/Screener'
      ),
  },
  {
    path: '/auth/login',
    name: 'AuthLogin',
    component: () =>
      import(
        /* webpackChunkName: "Auth" */
        '../views/auth/Login'
      ),
  },
  {
    path: '/auth/register',
    name: 'AuthRegister',
    component: () =>
      import(
        /* webpackChunkName: "Auth" */
        '../views/auth/Register'
      ),
  },
  {
    path: '/auth/forgotpass',
    name: 'AuthForgot',
    component: () =>
      import(
        /* webpackChunkName: "Auth" */
        '../views/auth/Forgot'
      ),
  },
  {
    path: '/auth/setpassword/:code',
    name: 'AuthSetPass',
    component: () =>
      import(
        /* webpackChunkName: "Auth" */
        '../views/auth/SetPassword'
      ),
  },
  {
    path: '/calendar',
    name: 'Calendar',
    component: () => import('../views/Calendar'),
  },
  {
    path: '/articles/:article?',
    name: 'Articles',
    component: () => import('../views/Articles'),
  },
  {
    path: '/ideas/:idea?',
    name: 'Ideas',
    component: () => import('../views/Ideas'),
  },
  {
    path: '*',
    redirect: '/screener/moex',
  },
]

const router = new VueRouter({
  mode: 'history',
  routes,
})

router.beforeEach(updateLanguage)

export default router
